import { TableShape, TableType } from '@backend/domain'
import { TablePriority } from '@core/types'
import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger'
import {
	IsDate,
	IsEnum,
	IsInt,
	IsNotEmpty,
	IsOptional,
	IsPositive,
	IsString,
	IsUUID,
	Length,
	Min,
} from 'class-validator'

export class TableResponse {
	@ApiProperty({ type: String, format: 'uuid' })
	id: string

	@ApiProperty({ type: String })
	name: string

	@ApiProperty({ type: Number })
	capacity: number

	@ApiProperty({ type: Number })
	width: number

	@ApiProperty({ type: Number })
	height: number

	@ApiProperty({ type: Number })
	columnStart: number

	@ApiProperty({ type: Number })
	rowStart: number

	@ApiProperty({ enum: TablePriority })
	priority: TablePriority

	@ApiProperty({ enum: TableShape })
	shape: TableShape

	@ApiPropertyOptional({ type: String, isArray: true, format: 'uuid' })
	subscribers?: string[]
}

export class SaveTableRequest {
	@ApiPropertyOptional({ type: String, format: 'uuid' })
	@IsOptional()
	@IsUUID()
	id?: string

	@ApiProperty({ type: String, minLength: 1, maxLength: 30 })
	@IsNotEmpty()
	@IsString()
	@Length(1, 30)
	name: string

	@ApiProperty({ type: Number })
	@IsNotEmpty()
	@IsInt()
	@IsPositive()
	capacity: number

	@ApiProperty({ type: Number })
	@IsNotEmpty()
	@IsInt()
	@IsPositive()
	width: number

	@ApiProperty({ type: Number })
	@IsNotEmpty()
	@IsInt()
	@IsPositive()
	height: number

	@ApiProperty({ type: Number, minimum: 0 })
	@IsNotEmpty()
	@IsInt()
	@Min(0)
	columnStart: number

	@ApiProperty({ type: Number, minimum: 0 })
	@IsNotEmpty()
	@IsInt()
	@Min(0)
	rowStart: number

	@ApiProperty({ enum: TableShape })
	@IsNotEmpty()
	@IsEnum(TableShape)
	shape: TableShape

	@ApiProperty({ enum: TablePriority })
	@IsNotEmpty()
	@IsEnum(TablePriority)
	priority: TablePriority

	@ApiPropertyOptional({ type: String, isArray: true, format: 'uuid' })
	@IsOptional()
	subscribers?: string[]
}

export class FindAvailableTablesByTimeSlotRequest {
	@ApiProperty({ type: Date })
	@IsNotEmpty()
	@IsDate()
	start: Date

	@ApiProperty({ type: Date })
	@IsNotEmpty()
	@IsDate()
	end: Date

	@ApiProperty({ type: Number })
	@IsNotEmpty()
	@IsInt()
	@IsPositive()
	noOfPersons: number
}

export class FindAvailableTableByIdRequest {
	@ApiProperty({ type: String, format: 'uuid' })
	@IsNotEmpty()
	@IsUUID()
	id: string

	@ApiProperty({ enum: TableType })
	@IsNotEmpty()
	@IsEnum(TableType)
	type: TableType
}

export class FindAvailableTablesByTimeSlotResponse {
	@ApiProperty({ type: String, format: 'uuid' })
	id: string

	@ApiProperty({ type: String })
	name: string

	@ApiPropertyOptional({ type: String, isArray: true })
	tableNames?: string[]

	@ApiProperty({ enum: TableType })
	type: TableType

	@ApiProperty({ type: Number })
	capacity: number

	@ApiPropertyOptional({ type: Boolean })
	hasUnconfirmedReservation?: boolean
}
